import React from 'react';
import SimpleLineIcon from "react-simple-line-icons";
import "./Map.scss";
import {Nav} from "../../Components";

function Map() {
    return(
        <div className="map-container">

            <div className="map-search-box">
                <div className="map-search-box-inner">
                    <input type="text" name="" id="" placeholder="دنبال چی میگردی؟"/>
                    <div><SimpleLineIcon name="magnifier" /></div>
                </div>
            </div>

            <div className="map-body">

            </div>

            <Nav/>
        </div>
    )
}

export {Map};